import { useSceneLoading } from '@editor/hooks'

interface Props {
  description?: string
}

const SceneLoadingIndicatorFallback = ({ description }: Props) => {
  useSceneLoading({ description, enabled: true })

  return null
}

export default SceneLoadingIndicatorFallback
